import { generateUtilityClasses, ListItemText, listItemTextClasses, styled } from '@mui/material';

export const COMPONENT_NAME = 'PrcDocumentListItemText';

export const documentListItemTextClasses = {
  ...listItemTextClasses,
  ...generateUtilityClasses(COMPONENT_NAME, ['clamp']),
};

export const DocumentListItemTextStyled = styled(ListItemText)({
  [`& .${documentListItemTextClasses.clamp}`]: {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'wrap',
    wordBreak: 'break-word',
  },
});
